module.exports = __webpack_public_path__ + "assets/media/3.95f0c40a.wav";